import React from "react";
import { connect } from "react-redux";

import { Translate, withI18n } from "@quantum/i18n";

import { compose } from "ramda";

import SelectInput from "../../../../comum/SelectInput";

import {
  type ActionCreator,
  getTiposDataReferenciaAnaliseHorizontal,
  getComparacaoSelecionada,
  selecionarComparacao,
} from "../../../../../state";
import { type Id } from "../../../../../model";

type Props = {
  listaComparacao: Array<TipoCalculo>,
  comparacaoSelecionada: Id,
  selecionarComparacao: ActionCreator,
};

const SelecaoComparacaoAnaliseHorizontal = ({
  listaComparacao,
  comparacaoSelecionada,
  selecionarComparacao,
}: Props) => {
  const onChangeComparacao = id => selecionarComparacao(id);

  return (
    <>
      <label className="ConfiguracaoMedida__label">
        <Translate>Periodo.AnaliseHorizontal.Comparacao</Translate>
      </label>
      <SelectInput
        className="ConfiguracaoMedida__input-select"
        value={comparacaoSelecionada}
        options={listaComparacao}
        onChange={onChangeComparacao}
        multiple={false}
        size={1}
        campoId={"codigo"}
        campoDescricao={"traducao"}
      />
    </>
  );
};

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaComparacao: getTiposDataReferenciaAnaliseHorizontal(state).map(
        tipo => ({
          ...tipo,
          traducao: ownProps.translate(tipo.descricao),
        })
      ),
      comparacaoSelecionada: getComparacaoSelecionada(state),
    }),
    {
      selecionarComparacao,
    }
  )
)(SelecaoComparacaoAnaliseHorizontal);
